import { render, staticRenderFns } from "./ClientTeam.vue?vue&type=template&id=01dfdeb4&scoped=true"
import script from "./ClientTeam.vue?vue&type=script&lang=js"
export * from "./ClientTeam.vue?vue&type=script&lang=js"
import style0 from "./ClientTeam.vue?vue&type=style&index=0&id=01dfdeb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dfdeb4",
  null
  
)

export default component.exports